import { useI18n } from "../i18n";

export function formatDuration(duration: number) {
    const hours = Math.floor(duration / 3600000);
    const minutes = Math.floor((duration % 3600000) / 60000);
    const { getI18n } = useI18n()

    const formattedString = (hours > 0 ? `${hours}${getI18n()?.formatMessage({ id: 'HOUR' })} ` : '') + (minutes > 0 ? `${minutes}${getI18n()?.formatMessage({ id: 'MINUTE' })}` : '');

    return formattedString;
}

export function formatDurationFromTime(startTime: any, endTime: any) {
    let formattedString = '';
    const { getI18n } = useI18n()
    if(!isNaN(startTime) && !isNaN(endTime))
    {
        const duration = endTime - startTime;
        const hours = Math.floor(duration / 3600000);
        const minutes = Math.floor((duration % 3600000) / 60000);
        const seconds =  Math.floor( ((duration % 3600000) % 60000) / 1000);
        
        formattedString = (hours > 0 ? `${hours}${getI18n()?.formatMessage({ id: 'HOUR' })} ` : '') + (minutes > 0 ? `${minutes}${getI18n()?.formatMessage({ id: 'MINUTE' })} ` : '') + (seconds > 0 ? `${seconds}${getI18n()?.formatMessage({ id: 'SECONDS' })}` : '');
    }
    return formattedString;
}